import axios from 'axios'
import { takeEvery, put, all, call } from 'redux-saga/effects'
import { application } from '../../../../../redux/store'
import { DuesGroupTypes } from './types'
import toast from 'react-hot-toast'
import {
  addDuesGroup,
  deleteDuesGroup,
  handlePost,
  showDuesGroup,
  updateDuesGroup,
} from './slice'

function* showDuesGroupHandler({ page }) {
  try {
    const response = yield call(() =>
      axios.get(`${application.api}/groups?page=${page}&type=2`)
    )
    yield put(showDuesGroup(response.data.data.Records))
  } catch (error) {}
}

function* addDuesGroupHandler({ payload }) {
  try {
    const response = yield call(() =>
      axios.post(`${application.api}/group`, payload.values)
    )
    yield put(addDuesGroup(response.data.data))
    yield showDuesGroupHandler(payload)
    yield put(handlePost(true))
    toast.success(response.data.description)
  } catch (error) {
    yield put(handlePost(false))
    toast.error(error.response.data.description)
  }
}

function* updateDuesGroupHandler({ payload }) {
  try {
    const response = yield call(() =>
      axios.put(`${application.api}/group`, payload)
    )
    yield put(updateDuesGroup(payload))
    toast.success(response.data.description)
  } catch (error) {
    toast.error(error.response.data.description)
  }
}
function* deleteDuesGroupHandler({ payload }) {
  try {
    const response = yield call(() =>
      axios.delete(`${application.api}/group`, {
        data: {
          id: payload.id,
        },
      })
    )
    yield put(deleteDuesGroup(payload.id))
    yield showDuesGroupHandler(payload)
    toast.success(response.data.description)
  } catch (error) {
    toast.error(error.response.data.description)
  }
}

export function* DefDuesGroupSagas() {
  yield all([
    takeEvery(DuesGroupTypes.SHOW_DUES_GROUP, showDuesGroupHandler),
    takeEvery(DuesGroupTypes.ADD_DUES_GROUP, addDuesGroupHandler),
    takeEvery(DuesGroupTypes.UPDATE_DUES_GROUP, updateDuesGroupHandler),
    takeEvery(DuesGroupTypes.DELETE_DUES_GROUP, deleteDuesGroupHandler),
  ])
}
